import { SITE } from "../lib/site";

/**
 * CS-5A — the one layout every signed-out page uses (sign in, forgot, activate, reset, forced change): a single
 * centred column, at most 420px, full width inside the page padding on a phone (business/20; plan §26).
 */
export default function AuthCard({ icon = "bi-buildings", title, subtitle, children, footer }) {
  return (
    <div className="vp-auth d-flex align-items-center justify-content-center px-3 py-4" style={{ minHeight: "100dvh" }}>
      <div className="w-100" style={{ maxWidth: 420 }}>
        <div className="text-center mb-4">
          <i className={`bi ${icon}`} style={{ fontSize: 30, color: "var(--vp-brand)" }} aria-hidden="true" />
          <div className="small text-muted mt-2">{SITE.name}</div>
          <h1 className="h5 mt-1 mb-0">{title}</h1>
          {subtitle && <p className="text-muted small mb-0 mt-1">{subtitle}</p>}
        </div>
        <div className="card border-0 shadow-sm">
          <div className="card-body p-4">{children}</div>
        </div>
        {footer && <div className="text-center mt-3">{footer}</div>}
      </div>
    </div>
  );
}

/** The checking / inspecting state shared by the link pages. */
export function AuthChecking({ label }) {
  return (
    <div className="text-center py-3" role="status">
      <span className="spinner-border spinner-border-sm me-2" aria-hidden="true" />
      {label}
    </div>
  );
}
